export interface ILocation {
  lat: number;
  lng: number;
}

export const haversineDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
): number => {
  const R = 6371;
  const dLat = Math.abs(lat2 - lat1);
  const dLon = Math.abs(lon2 - lon1);

  // Umrechnung der Graddifferenzen in Bogenmaß
  const x = dLat * (Math.PI / 180) * R;
  const y =
    dLon * (Math.PI / 180) * R * Math.cos((lat1 + lat2) * (Math.PI / 360));

  return Math.sqrt(x * x + y * y); // Distance in km
};

export const calculateConsultantDistance = async (
  userLocation: ILocation,
  consultantAddress: string,
): Promise<string | null> => {
  try {
    // Split the consultantAddress string into lat and lng
    const [lat, lng] = consultantAddress.split(',').map(Number);

    if (lat && lng) {
      const distance = haversineDistance(
        userLocation.lat,
        userLocation.lng,
        lat,
        lng,
      );
      return distance.toFixed(2); // Returns the distance in km
    }

    return null;
  } catch (error) {
    return null;
  }
};
